// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-r_fO","storyDetailListWrapper__title":"c-r_fP","storyDetailListWrapper__timeline":"c-r_fQ","storyDetailListWrapper__list":"c-r_fR"};